export {default} from './HealthcareProviderScreen.connect';
